"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _axios = _interopRequireDefault(require("axios"));
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var XLSX = _interopRequireWildcard(require("xlsx"));
var _papaparse = _interopRequireDefault(require("papaparse"));
require("./Uploader.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class Uploader extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleUpload = this.handleUpload.bind(this);

    // Set up local state
    this.state = {
      failuredFunds: null
    };
  }

  // Handle upload of a portfolio
  handleUpload(acceptedFiles) {
    const reader = new FileReader();
    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading has failed');
    reader.onload = () => {
      const binary = reader.result;
      const wb = XLSX.read(binary, {
        type: 'binary'
      });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const file_contents = _papaparse.default.parse(XLSX.utils.sheet_to_csv(ws).replace(/\s+,/g, ','));
      var holdings = file_contents.data.filter(function (holding) {
        return holding[0] !== null && holding[0].toLowerCase() !== 'tickers' && holding[0].length > 0;
      }).map(function (holding) {
        return holding;
      });

      // Check the tickers provided against the API
      this.checkTickers(holdings);
    };
    reader.readAsBinaryString(acceptedFiles[0]);
  }
  async checkTickers(holdings) {
    const {
      token,
      totalValue
    } = this.props;
    const {
      updateHoldings,
      checkTickersUrl
    } = this.props;
    const tickers = holdings.map(holding => {
      return holding[0];
    });
    const weights = holdings.map(holding => {
      return holding[1];
    });

    // Convert the weights to numbers so we can sum them up
    const weightsAsNumbers = holdings.map(holding => {
      return +holding[1].replace(/[^0-9.-]+/g, '');
    });
    const totalWeight = weightsAsNumbers.reduce(function sumofArray(sum, num) {
      return sum + num;
    });
    const request = {
      method: 'POST',
      url: "".concat(checkTickersUrl, "/api/securityfund/ticker_names/"),
      data: JSON.stringify({
        tickers
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: token && "Token ".concat(token)
      }
    };
    (0, _axios.default)(request).then(response => {
      if (response.status === 200) {
        const data = response.data;
        let results = [];
        let failures = [];
        data.tickers.forEach((ticker, i) => {
          const weightColType = weights[i].includes('%') ? 'weight' : 'amount';
          const weight = weights[i].includes('%') ? +weights[i].replace(/[^0-9.-]+/g, '') / 100 : +weights[i].replace(/[^0-9.-]+/g, '');
          const row = {
            ticker,
            name: data.names[i],
            amount: weightColType === 'weight' ? weight * totalValue : weight,
            externalID: data.externalIDs[i],
            weight: weightColType === 'weight' ? +weights[i].replace(/[^0-9.-]+/g, '') / 100 : +weights[i].replace(/[^0-9.-]+/g, '') / totalWeight
          };

          // Add the fund to the result set
          if (row.name !== 'UNKNOWN') {
            results.push(row);
          } else {
            failures.push(row);
          }
        });
        if (failures.length > 0) {
          // Update the failed funds
          this.setState({
            failuredFunds: failures
          });

          // Remove the failed funds notice after 10 secs
          setTimeout(() => this.setState({
            failuredFunds: null
          }), 5000);
        }
        if (results.length === 0) {
          return;
        }

        // Send back to the passed in function
        updateHoldings(results);
      }
    });
  }
  render() {
    const {
      downloadTemplateLabel,
      downloadTemplateTooltipLabel,
      placeholderLabel,
      uploadFailureLabel
    } = this.props;
    const {
      failuredFunds
    } = this.state;
    let failedFundsString = '';

    // Set up a string of failed fund tickers
    if (failuredFunds) {
      failuredFunds.forEach(fund => {
        failedFundsString = failedFundsString + fund.ticker + ', ';
      });
      failedFundsString = failedFundsString.slice(0, -2);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "port-uploader"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "dropzone-container"
    }, /*#__PURE__*/_react.default.createElement(_reactDropzone.default, {
      onDrop: acceptedFiles => {
        console.log(acceptedFiles);
        this.handleUpload(acceptedFiles);
      }
    }, _ref => {
      let {
        getRootProps,
        getInputProps
      } = _ref;
      return /*#__PURE__*/_react.default.createElement("section", {
        className: "dropzone-section"
      }, /*#__PURE__*/_react.default.createElement("div", _extends({}, getRootProps(), {
        className: "dropzone"
      }), /*#__PURE__*/_react.default.createElement("input", getInputProps()), /*#__PURE__*/_react.default.createElement("p", null, placeholderLabel)));
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "template"
    }, /*#__PURE__*/_react.default.createElement("a", {
      title: downloadTemplateTooltipLabel,
      href: "https://www.wisdomtree.com/-/media/us-media-files/advisor-solutions/digital-portfolio-developer/xls/capgainstemplate.xlsx",
      _target: "blank"
    }, downloadTemplateLabel)), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('failures', failuredFunds ? 'show' : '')
    }, uploadFailureLabel, /*#__PURE__*/_react.default.createElement("span", {
      className: "tickers"
    }, failedFundsString)));
  }
}
_defineProperty(Uploader, "defaultProps", {
  checkTickersUrl: 'https://dpd.wisdomtree.com',
  updateHoldings: null,
  // Method called when holdings are updated 
  placeholderLabel: null,
  token: null,
  totalValue: 1000000,
  downloadTemplateLabel: 'Download Template',
  downloadTemplateTooltipLabel: 'Download an example Excel template you can update with your tickers.',
  uploadFailureLabel: 'The following tickers could not be found: '
});
var _default = exports.default = Uploader;